/**
 * cleanProceedingName — tidy the raw ECFS proceeding title for display.
 *
 * ECFS titles frequently carry trailing artifacts from how the source text was
 * captured — stray " . .", a lone dangling period, or trailing whitespace
 * (e.g. "…Act of 1992. . ." or "…U.S.C. 160. .."). ~40 open proceedings have
 * this. Collapse the trailing punctuation/space noise for display without
 * touching the stored value. Interior text (including legitimate typos in the
 * FCC's own data) is left alone.
 */
export function cleanProceedingName(name?: string | null): string {
  if (!name) return '';
  return name
    .replace(/\s+/g, ' ')                       // collapse internal runs of whitespace
    // Strip trailing artifact runs that begin with a *space before* a period
    // (" .", " . .", " ...") — the tell-tale of a dangling fragment. Requiring
    // the leading space preserves abbreviation periods glued to the last word,
    // so "…U.S." and "…Inc." keep their period while "…1992. . ." → "…1992."
    .replace(/\s+\.[\s.]*$/, '')
    .trim();
}
